import React, {Fragment} from "react";
import NsDataTable from "../../components/tabelle/NsDataTable";
import ModalMsg from "../../components/ModalMsg";

export default function DocumentiSocioView({
                                               documenti,
                                               downloadDocumento,
                                               showMsg,
                                               setShowMsg,
                                               modalMsg
                                           }) {

    return (
        <Fragment>
            <ModalMsg
                show={showMsg}
                handleClose={() => setShowMsg(false)}
                testo={modalMsg}
            />
            <NsDataTable
                data={documenti}
                columns={[
                    {
                        name: 'Documento',
                        selector: row => row.nome_file,
                        sortable: true,
                    },
                    {
                        name: 'Descrizione',
                        selector: row => row.descrizione || '-',
                        sortable: true,
                    },
                    {
                        name: 'Categoria',
                        selector: row => row.categoria,
                        sortable: true,
                    },
                    {
                        name: '',
                        selector: row =>
                            <button className="btn btn-sm btn-dark"
                                    data-toggle="tooltip" title="Download" onClick={() => {
                                downloadDocumento(row)
                            }}>
                                <i className="fas fa-download"/> Scarica
                            </button>,
                        sortable: false,
                        right: true,
                    }
                ]}
                addPagination={false}
                addFiltri={false}
            />
        </Fragment>
    );

}